import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import HotList from "@/pages/home/components/HotList";
import TvUpdates from "@/pages/home/components/TvUpdates";

const features = [
  { icon: "ri-film-line", title: "海量片库", desc: "电影、电视剧多类型覆盖，持续补充新内容" },
  { icon: "ri-hd-line", title: "高清画质", desc: "精选高清影视资源，尽享清晰观影体验" },
  { icon: "ri-apps-2-line", title: "分类清晰", desc: "类型、地区、年份多维筛选，快速定位" },
  { icon: "ri-refresh-line", title: "持续更新", desc: "热播剧集同步追更，剧集进度一目了然" },
];

export default function Home() {
  return (
    <div className="w-full">
      <HeroCarousel />
      <CategoryGrid />

      <section className="px-4 md:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {features.map((f) => (
            <div
              key={f.title}
              className="flex items-start gap-3 p-5 rounded-lg border border-background-200 bg-background-50"
            >
              <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-md bg-primary-50 text-primary-600">
                <i className={`${f.icon} text-xl`}></i>
              </span>
              <div>
                <h3 className="text-sm font-heading font-semibold text-foreground-950">{f.title}</h3>
                <p className="mt-1 text-xs font-body text-foreground-500 leading-relaxed">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <HotList />
      <TvUpdates />
    </div>
  );
}